import SidebarBottomMenu from './SidebarBottomMenu';

export default SidebarBottomMenu;
